import { render, staticRenderFns } from "./AssignmentDetail.vue?vue&type=template&id=d89bda44&scoped=true"
import script from "./AssignmentDetail.vue?vue&type=script&lang=js"
export * from "./AssignmentDetail.vue?vue&type=script&lang=js"
import style0 from "./AssignmentDetail.vue?vue&type=style&index=0&id=d89bda44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89bda44",
  null
  
)

export default component.exports